import React from 'react';
import { GRID_COL_INDEX_ATTRIBUTE } from '@gulfwinds/ui-components';

const BaseCell = ({
  children,
  colSpan,
  columnIndex,
  ariaColumnIndex,
  isSelected,
  selectable = true,
  tooltip,
  ...props
}) => (
  <td
    role='gridcell'
    colSpan={colSpan}
    aria-colindex={ariaColumnIndex}
    aria-selected={isSelected}
    title={tooltip}
    {...(selectable ? {
      [GRID_COL_INDEX_ATTRIBUTE]: columnIndex,
    } : {})}
    {...props}
  >
    {children}
  </td>
);

export default BaseCell;
